<ng-progress color="red" [thick]="true" [spinner]="false" [trickleSpeed]="500" [ease]="'easeInSine'" (started)="ngProgress.startedClass" (completed)="ngProgress.endedClass"></ng-progress>

<div class="subBlockContent" id="widerIframe">
    <child-header title="New Digital Wallet" (closeEvent)="closeRightPanel()"></child-header>
    <div class="inner-subBlock-wrapper">
        <!-- <div class="title blade-title-font">
            New Digital Wallet
        </div>
        <i class="material-icons closebutton-pullfloat-right" (click)="closeRightPanel()">close</i> -->
        <!-- Step One -->
        <div class="form-container" [formGroup]="paymentGroup" *ngIf="paymentForm">
            <div class="new-payment">
                <div class="payment-row">
                    <label class="payment-row-title">Name Your Payment Option *</label>
                    <div class="payment-row-control">
                        <input type="text" placeholder="e.g. Bank Corporate Credit Card" onfocus="this.placeholder=''"
                            onblur="this.placeholder='e.g. Bank Corporate Credit Card'" class="customerNameValidate"
                            formControlName="customerName"
                            (blur)="isNotValidField('customerName', '.customerNameValidate')" />
                    </div>
                </div>

                <div class="payment-row">
                    <div class="payment-row-control">
                    </div>
                </div>
                <div class="payment-row">
                    <div class="payment-row-control">
                        <mat-slide-toggle formControlName="paywayPersonalUse">
                            <span [ngbTooltip]="companyWideUseTip" placement="top" class="payment-row-title">
                                Company wide use
                                <img class="attention-img" src="../images/new_ui/attention.png">
                            </span>
                        </mat-slide-toggle>
                    </div>
                </div>
                <div class="payment-row">
                    <div class="payment-row-control">
                        <label>Max Authorised AMT</label>
                        <span [ngbTooltip]="amtTip" placement="top" class="display-inline-block">
                            <img class="attention-img" src="../images/new_ui/attention.png">
                        </span>
                        <input type="text" id="maxAuthorisedAmount" class="amtValidate"
                            formControlName="maxAuthorisedAmount" />
                    </div>
                </div>
            </div>
            <div class="button-center">
                <button type="button" id="nextBtn" class="button button-red button-large"
                    (click)="registerPayment()">Save</button>
            </div>
        </div>
        <div id="msg" style="visibility: hidden;"></div>
        <div id="card_type" style="visibility: hidden;"></div>

        <!-- Step Two -->
        <div class="payment-setup" *ngIf="!paymentForm">
            <div class="page-title-description">
                The information you provide here is stored directly with Westpac Banking Corporation to ensure all
                PCI standards complied with.
            </div>
            <div class="payment-option" ngbRadioGroup name="radioBasic" [(ngModel)]="selectedPaymentMethod">
                <label ngbButtonLabel>
                    <input type="radio" ngbButton value="creditcard" class="cc" (click)="showCCForm()">
                    <span>CREDIT CARD</span>
                </label>
                <label ngbButtonLabel>
                    <input type="radio" ngbButton value="bankaccount" class="ba" (click)="showBAForm()">
                    <span>BANK ACCOUNT</span>
                </label>
            </div>
            <div class="credit-card" *ngIf="selectedPaymentMethod == 'creditcard'">
                <div class="align-center">
                    <form>
                        <div id="payway-credit-card"></div>
                    </form>
                    <button class="button button-red button-large margin-t-x15" id="payway-cc-submit"
                        (click)="paywayLanding('cc')" disabled>Register</button>
                    <button class="button payment-back" (click)="backToForm()">Previous</button>
                </div>
            </div>
            <div class="bank-account" *ngIf="selectedPaymentMethod == 'bankaccount'">
                <div class="align-center">
                    <form>
                        <div id="payway-bank-account"></div>
                    </form>
                    <button class="button button-red button-large" id="payway-ba-submit" (click)="paywayLanding('ba')"
                        disabled>Register</button>
                    <button class="button payment-back" (click)="backToForm()">Previous</button>
                </div>
            </div>

        </div>
    </div>
</div>
<ng-template #companyWideUseTip>
    <div class="padding-x10">
        <div class="tooltip-title">Show this payment method everyone in your company to use</div>
    </div>
</ng-template>

<ng-template #amtTip>
    <div class="padding-x10">
        <div class="tooltip-title">Maximum amount can be used to make automatic payments</div>
    </div>
</ng-template>